import { queryOptions, useQuery } from '@tanstack/react-query'

import { env } from '@/src/config/env'
import { getIsLoggedIn } from '@/src/features/auth/utils/getIsLoggedIn'

import { notificationApi } from '../api/notificationApi'
import type { TGetNotificationsPayload } from '../api/types/getNotifications.types'
import type { TNotificationObjectType } from '../api/types/notificationApi.types'

type TUseNotificationsPayload = Omit<TGetNotificationsPayload, 'object'> & {
  objectId?: number
  objectType?: TNotificationObjectType
}

export const getNotificationQueryOptions = ({ objectId, objectType, ...rest }: TUseNotificationsPayload = {}) =>
  queryOptions({
    queryKey: ['notifications', { objectId, objectType, ...rest }],
    queryFn: ({ signal }) =>
      notificationApi.getNotifications(
        { ...(objectId && objectType && { object: `${objectType}/${objectId}` }), ...rest },
        { signal },
      ),
    select: (data) => (Array.isArray(data) ? data : []),
    retry: 1,
    enabled: getIsLoggedIn(),
    refetchInterval: env.EXPO_PUBLIC_NOTIFICATIONS_POLLING_INTERVAL || 45 * 1000, // Fetch notifications every 45 seconds
    staleTime: 60 * 1000 * 3, // 3 minutes
  })

export const useNotificationsQuery = (payload: TUseNotificationsPayload = {}) =>
  useQuery(getNotificationQueryOptions(payload))
